
import FormInput2 from '@/components/forms/FormInput2.vue'
import environment from '@/helpers/Environment'
import { openTermsModal } from '@/helpers/ModalDialogs'
import type { LanguageStrings } from '@/language/types'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'TermsCheckbox',
  components: {
    FormInput2,
  },
})
export default class extends Vue {
  accepted = false

  t: LanguageStrings['termsCheckbox']

  get isRequired(): boolean {
    const content = environment.portalStrings.terms_and_conditions_dialog_content?.trim()
    return Boolean(content) && content.length > 0
  }

  onTermsCheckBoxClick() {
    // Uncheck the terms and conditions checkbox.
    this.accepted = false

    // Ignore declined terms and conditions if opened via checkbox.
    this.openTermsModal().catch(() => null)
  }

  validate(): Promise<void> {
    if (this.isRequired && !this.accepted) {
      // Open the terms dialog if they have not been accepted yet.
      return this.openTermsModal()
    } else {
      return Promise.resolve()
    }
  }

  openTermsModal(): Promise<void> {
    return new Promise((resolve, reject) => {
      openTermsModal(this.$t('termsModal.title') as string, (data) => {
        this.accepted = data?.accepted
        if (this.accepted) {
          resolve()
        } else {
          reject({ validationError: true })
        }
      })
    })
  }
}
